module.exports = {
          srcSet: __webpack_public_path__ + "05e115e3e9f150e17df58298553a6c8c-71.png"+" 71w",
          images:[ {path: __webpack_public_path__ + "05e115e3e9f150e17df58298553a6c8c-71.png",width: 71,height: 80}],
          src: __webpack_public_path__ + "05e115e3e9f150e17df58298553a6c8c-71.png",
          toString:function(){return __webpack_public_path__ + "05e115e3e9f150e17df58298553a6c8c-71.png"},
          
          width: 71,
          height: 80
        }